//生产环境走window.__env
// window.__env={
//   TASKCENTER_URL:"https://cloud.ketanyun.cn/taskcenter",
//   KNOWLEDGE_URL:"https://cloud.ketanyun.cn",
//   TASKAPI_URL:"https://cloud.ketanyun.cn/taskapi",
//   INFOPLUS_URL:"https://cloud.ketanyun.cn/infoplus/apis/v2",
//   SSO_URL:"https://cloud.ketanyun.cn/sso",
//   SSO_SCOPE:"profile+task+process+app",
//   SSO_KEY:"SKvpw2Nm1ZOSifdDeNUk",
// }
if(window.__env){
  window.commonApi=window.__env;
  //先用origin
  window.commonApi.KNOWLEDGE_BOT_URL = location.origin;
  window.commonApi.TASKCENTER_URL = location.origin + window.commonApi.PATH;
  window.commonApi.BUS_URL = location.origin + "/bus/graphql/"+ window.commonApi.SSO_KEY;
  window.commonApi.SSO_SCOPE = "profile task task_edit process openid data triple app profile_edit stats submit process_edit entrust entrust_edit"
}else{
  window.commonApi={
    TASKCENTER_URL:"/taskcenter",
    KNOWLEDGE_URL:"/bus/graphql/nBKkQfSGC8rsJl4HVIYn",
    TASKAPI_URL:"",
    INFOPLUS_BASE_URL:'/infoplus',
    INFOPLUS_URL:"/infoplus/apis/v2",
    SSO_URL:"https://cloud.ketanyun.cn/sso",
    BOT_URL:"/knowledge-bot",
    WSXT_URL:location.origin + "/bus/graphql/YJBoiNK0STofbJguN9n5",

    SSO_SCOPE:"profile task task_edit process openid data triple app profile_edit stats submit process_edit entrust entrust_edit",
    // SSO_KEY:"SKvpw2Nm1ZOSifdDeNUk",
    SSO_KEY:'ByYCH5BkYokdjOh2rYns',
    PATH:"",
    KNOWLEDGE_BOT_URL:"",
    BUS_URL:"/bus/graphql/ByYCH5BkYokdjOh2rYns"
  }
}

let redirect_uri= encodeURIComponent(window.location.href);
let client_id=window.commonApi.SSO_KEY;
let scope=window.commonApi.SSO_SCOPE;
let authority = window.commonApi.SSO_URL + "/oauth2";
export const oidcSettings = {
  authority: authority,
  metadata: {
      issuer: authority,
      authorization_endpoint: authority + "/authorize",
      userinfo_endpoint: authority + "/userinfo",
      end_session_endpoint: window.commonApi.INFOPLUS_BASE_URL + "/logout?redirect_uri=" + redirect_uri,
      jwks_uri: authority + "/jwks.json"
  },
  clientId: client_id,
  redirectUri: window.location.origin + window.commonApi.PATH +"/workflow/oidcCallback",
  responseType: "id_token token",
  scope: scope
};


// WEBPACK FOOTER //
// ./src/store/config/oidc.js